import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { each, map, findIndex } from 'lodash';
import { E_PackageTag } from '../apis/service/PackageApi.types';
let CompanyOrganizationCommonService = class CompanyOrganizationCommonService {
    constructor(PackageApi, MiscApi, DataResourceApi) {
        this.PackageApi = PackageApi;
        this.MiscApi = MiscApi;
        this.DataResourceApi = DataResourceApi;
        this._chargeModes = [];
    }
    isAnonymousPrivilege(item) {
        const isAnonymous = findIndex(item.package_vo_list, pkg => pkg.package_tag === E_PackageTag.ANONYMOUS) > -1;
        return isAnonymous;
    }
    getCompanyPrivilege(company_id) {
        return this.PackageApi.getCompanyPrivilege(company_id);
    }
    async getPackageChargetModes() {
        // 获取用户数据资源
        const resources = await this.getCurrentUserDataResource();
        const res = new Set();
        // 获取chargeModes 的数据  去重
        const allChargeModes = await this.getChargeModes();
        // 筛选出数据资源中符合要求的值
        each(resources, resource => {
            const code = resource.code;
            if (allChargeModes.includes(code)) {
                res.add(code);
            }
        });
        return res;
    }
    /**
     * 获取用户可以分配的套餐的ChargeModes（COMMERCIAL:ASSIGN为独权内的数据资源，需要单独处理）
     */
    async getCanAssignPackageChargeModes() {
        // 获取用户数据资源
        const resources = await this.getCurrentUserDataResource();
        const res = new Set();
        // 获取chargeModes 的数据  去重
        const allChargeModes = await this.getChargeModes();
        // 筛选出数据资源中符合要求的值
        each(resources, resource => {
            const code = resource.code;
            if (allChargeModes.includes(code) || code === 'COMMERCIAL:ASSIGN') {
                res.add(code === 'COMMERCIAL:ASSIGN' ? 'COMMERCIAL' : code);
            }
        });
        return res;
    }
    getCurrentUserDataResource() {
        return this.DataResourceApi.getCurrentUserDataResource();
    }
    getChargeModes() {
        if (this._chargeModes.length > 0) {
            return Promise.resolve(this._chargeModes);
        }
        return this.PackageApi.getChargeModes().then(data => {
            const chargeModes = map(data, code => code.system_code);
            this._chargeModes = chargeModes;
            /*  [ "COMMERCIAL", "TRIAL", "FREE", "INTERNAL", "HISTORICAL", "BETA" ] */
            return chargeModes;
        });
    }
    canUsePrivilege(item, userCanUseChargetModes) {
        const packageChargetModes = map(item.company_privilege_contract_duration_vo_list, p => p.charge_mode);
        return packageChargetModes.some((pitem) => {
            return userCanUseChargetModes.has(pitem);
        });
    }
};
CompanyOrganizationCommonService = __decorate([
    injectable(),
    __param(0, inject(Symbols.PackageApi)),
    __param(1, inject(Symbols.MiscApi)),
    __param(2, inject(Symbols.DataResourceApi)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CompanyOrganizationCommonService);
export { CompanyOrganizationCommonService };
